import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-discover-four',
  templateUrl: './discover-four.component.html',
  styleUrls: ['./discover-four.component.css']
})
export class DiscoverFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
